var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99994 14.4579C10.7501 14.4579 11.3583 13.8497 11.3583 13.0995C11.3583 12.3494 10.7501 11.7412 9.99994 11.7412C9.24975 11.7412 8.6416 12.3494 8.6416 13.0995C8.6416 13.8497 9.24975 14.4579 9.99994 14.4579Z",
    fill: "#F7FBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2332 7.94199V6.90033C15.2332 4.65033 14.6915 1.66699 9.99984 1.66699C5.30817 1.66699 4.7665 4.65033 4.7665 6.90033V7.94199C2.43317 8.23366 1.6665 9.41699 1.6665 12.3253V13.8753C1.6665 17.292 2.70817 18.3337 6.12484 18.3337H13.8748C17.2915 18.3337 18.3332 17.292 18.3332 13.8753V12.3253C18.3332 9.41699 17.5665 8.23366 15.2332 7.94199ZM9.99984 15.617C8.60817 15.617 7.48317 14.4837 7.48317 13.1003C7.48317 11.7087 8.6165 10.5837 9.99984 10.5837C11.3832 10.5837 12.5165 11.717 12.5165 13.1003C12.5165 14.492 11.3915 15.617 9.99984 15.617ZM6.12484 7.86699C6.05817 7.86699 5.99984 7.86699 5.93317 7.86699V6.90033C5.93317 4.45866 6.62484 2.83366 9.99984 2.83366C13.3748 2.83366 14.0665 4.45866 14.0665 6.90033V7.87533C13.9998 7.87533 13.9415 7.87533 13.8748 7.87533H6.12484V7.86699Z",
    fill: "#F7FBFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentLock);
export default __webpack_public_path__ + "static/media/payment_lock.7503e891e97e762e1be67f6f43bcbe86.svg";
export { ForwardRef as ReactComponent };